<template>
  <div class="login-feedback">
    <img src="./images/icon-feedback.svg" alt="" srcset="">
    <span>问题反馈</span>
    <div class="contact-info-popover">
      <div class="contact-info" @click="openFeedback">
        跨声联系：
        <span class="contact-name">蔡剑鸿-高级产品专员</span>
        <img class="contact-ks-icon" src="./images/ks.svg" alt="" srcset="">
      </div>
    </div>
  </div>
</template>

<script>
import { openKuasheng } from 'public/utils/open-ks'
export default {
  data() {
    return {
      feedbackEmployeeNumber: '601923'
    }
  },
  methods: {
    openFeedback() {
      openKuasheng(this.feedbackEmployeeNumber)
    }
  }
}
</script>

<style scoped lang="scss">
.login-feedback {
  gap: 6px;
  border-radius: 6px;
  background: rgba(252, 254, 255, 1);
  font-size: 12px;
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  color: rgba(47, 46, 56, 1);
  height: 32px;
  line-height: 32px;
  position: absolute;
  right: 110px;
  top: 12px;
  &:hover {
    background: rgba(252, 254, 255, 0.9);
    .contact-info-popover{
      display: block;
    }
  }
  img {
    width: 12px;
    height: 12px;
  }
  .contact-info-popover {
    display: none;
    position: absolute;
    top: 31px;
    &::before {
      content: '';
      width: 100%;
      height: 5px;
      background: transparent;
      display: block;
    }
    .contact-info {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px;
      border-radius: 6px;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
      background: rgba(255, 255, 255, 1);
      color: rgba(47, 46, 56, 1);
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      white-space: nowrap;
    }
    .contact-name {
      color: var(--g-color-primary);
    }
    .contact-ks-icon {
      width: 12px;
      margin-left: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/login-feedback.vue